import { EventObject } from '@xstate/store-react';
import { log } from '@domgen/shared/utils/log';
import { AppRoute } from '../../enums/appRoutes';
import { StepKey } from '../../enums/stepKey';
import { StoreEvent } from '../../enums/storeEvent';
import { StoreContext } from '../../models/store/context';

export const restartJourney = <T extends EventObject = EventObject>(
  context: StoreContext,
  _event: T,
  enqueue: {
    effect: (effect: () => Promise<void>) => void;
    emit: { navigate: (payload: { path: AppRoute; replace?: boolean }) => void };
  },
): StoreContext => {
  log.debug({ message: StoreEvent.RESTART_JOURNEY });
  enqueue.emit.navigate({ path: AppRoute.LANDING, replace: true });

  const newForm: Partial<StoreContext['form']> = {};
  if (context.form[StepKey.PERSONAL_DETAILS]) {
    newForm[StepKey.PERSONAL_DETAILS] = context.form[StepKey.PERSONAL_DETAILS];
  }

  return {
    ...context,
    form: newForm,
    quote: undefined,
    checkout: undefined,
    confirmation: undefined,
    applianceLookupResults: undefined,
    gaEventData: undefined,
  };
};
